'use client';

import React, { createContext, useMemo } from 'react';
import { useAbility as useCaslAbility } from '@casl/react';

import { AppAbility, createUserAbility } from '~/shared/auth/permissions';
import { useUserAbilities } from '~/shared/hooks/useUserAbilities';

export const AbilityContext = createContext({} as AppAbility);

type AbilityProviderProps = {
  children: React.ReactNode;
};

export function AbilityProvider({ children }: AbilityProviderProps) {
  const { data: abilitiesData } = useUserAbilities();

  const ability = useMemo(
    () => createUserAbility(undefined, undefined, abilitiesData?.abilities),
    [abilitiesData?.abilities]
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}

export function useAbility() {
  return useCaslAbility(AbilityContext);
}
